import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/element_style/theme/index.css'
// 添加全局样式
import './assets/css/global.css'

// 导入axios
import axios from 'axios'
// 挂载axios
Vue.prototype.$http = axios
// 设置访问根路径，接口请求地址
// axios.defaults.baseURL = "http://localhost:8080/visitorspring"
axios.defaults.baseURL = "https://os.qlu.edu.cn/visitorspring"

import store from './store'


router.beforeEach((to,from,next) => {
  if(to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


